import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { disabledState } from "../../theme/disabledState";
import { gridStyle } from "../Grid/Grid.css";

export const DEFAULT_FLOW_CARD_WIDTH = 340;

export const flowCardStyle = recipe({
  base: {},
  variants: {
    width: {
      default: {
        width: rem(DEFAULT_FLOW_CARD_WIDTH),
        selectors: {
          [`${gridStyle} &`]: {
            width: "100%",
          },
        },
      },
      stretch: {
        width: "100%",
      },
    },
    disabled: {
      true: {
        ...disabledState,
        opacity: "0.5 !important",
      },
    },
  },
  defaultVariants: {
    width: "default",
  },
});

export const flowCardContentStyle = recipe({
  base: {
    gap: theme.spacings.s,
  },
});

export const buttonStyle = style({
  pointerEvents: "none",
  alignSelf: "flex-start",
  marginTop: theme.spacings.xs,
});

export const descriptionStyle = style({
  flexGrow: 1,
});
